export default "__VITE_ASSET__BLvHvcPL__"